import RequestDTO from '../RequestDTO';

export default class NoticeRequestDTO extends RequestDTO {
  user_num_key: string;
  year_month: string;

  constructor(user_num_key: string, year_month: string) {
    super('NP_NOTICE');
    this.user_num_key = user_num_key;
    this.year_month = year_month;
  }
}
